import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import { useDrawer } from '../../drawer-context';
import { useThreekit } from '../../threekit-context';
import DrawerCategoryButtonGroup from '../drawer-category-button-group';
import getDrawerCategories from '../util/getDrawerCategories';
import HardwareSelector from './hardware-drawer-selector';

function HardwareDrawer() {
  const { productTag, getProductsFromAttribute } = useThreekit();
  const { drawerCategory, drawerName, setDrawerCategory } = useDrawer();
  const drawerCategories = getDrawerCategories(productTag, drawerName);
  const foundDrawerCategory = drawerCategories.find(
    (category) => category === drawerCategory,
  );

  let products = [];
  switch (drawerCategory) {
  case 'Axis':
    products = getProductsFromAttribute('Axis Color');
    break;
  case 'Screws':
    products = getProductsFromAttribute('Screws Color');
    break;
  case 'Clip':
    products = getProductsFromAttribute('Clip');
    break;
  case 'Pivot Collar':
    products = getProductsFromAttribute('Pivot Collar');
    break;
  case 'Spacers & Thumb Lug':
    products = getProductsFromAttribute('Thumbstude & Spacer Color');
    if (products.length === 0) products = getProductsFromAttribute('Backspacer'); // some knives use this attribute for spacers
    if (products.length === 0) products = getProductsFromAttribute('Barrel Spacers Color'); // some knives use this attribute for spacers
    break;
  case 'Backspacer':
    products = getProductsFromAttribute('Thumbstude & Spacer Color');
    if (products.length === 0) products = getProductsFromAttribute('Backspacer');
    break;
  default:
    break;
  }

  useEffect(() => {
    if (drawerName === 'Hardware') {
      setDrawerCategory(foundDrawerCategory || drawerCategories[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerName]);

  return (
    <>
      <DrawerCategoryButtonGroup categories={drawerCategories} />
      {drawerCategory === 'Clip' && <HardwareSelector products={products} />}
      {drawerCategory === 'Screws' && <HardwareSelector products={products} />}
      {drawerCategory === 'Axis' && <HardwareSelector products={products} />}
      {(drawerCategory === 'Spacers & Thumb Lug'
        || drawerCategory === 'Backspacer') && (
        <HardwareSelector products={products} square={true} />
      )}
      {drawerCategory === 'Pivot Collar' && (
        <HardwareSelector products={products} square={true} />
      )}
    </>
  );
}

export default HardwareDrawer;
